<template>
  <span class="click-copy" :title="title || '复制'" @click.stop="handleCopy">
    <slot></slot>
  </span>
</template>

<script>
export default {
  props: ['title', 'content', 'successMsg', 'errorMsg'],
  methods: {
    handleCopy () {
      this.doCopy(this.content)
        .then(() => {
          this.$toast.success(this.successMsg || '复制成功')
        })
        .catch(() => {
          this.$toast.fail(this.errorMsg || '复制失败')
        })
    },
    doCopy (content) {
      if (navigator.clipboard) {
        return navigator.clipboard.writeText(content)
      } else if (document.execCommand) {
        const textarea = document.createElement('textarea')
        textarea.value = content
        document.body.appendChild(textarea)
        textarea.focus()
        textarea.select()
        const result = document.execCommand('copy')
        document.body.removeChild(textarea)
        // eslint-disable-next-line
        return result ? Promise.resolve() : Promise.reject()
      }
      return Promise.reject(new Error('浏览器不支持复制'))
    }
  }
}
</script>
<style lang="stylus" scoped>
.click-copy
  display inline-block
  background #EAEAEA
  height 18px
  line-height 18px
  padding 0 8px
  font-size 12px
  color #797979
  margin-left 5px
  border-radius 18px
</style>
